import useLocale from 'next-translate/useTranslation';
import React from 'react';

import { ImageModelChipsMarquee } from './ImageHero';

const HIGHLIGHTS = [
  ['40+', 'image models'],
  ['4K', 'max resolution'],
  ['1', 'credit and up'],
  ['✓', 'commercial use'],
];

const ImageModelsBand = () => {
  const { t } = useLocale('ai-image-generator');

  return (
    <section
      id='models'
      className='relative border-y border-white/[0.06] bg-white/[0.02] py-16 lg:py-20'
    >
      <div className='mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8'>
        <h2 className='text-3xl font-extrabold tracking-tight text-white md:text-4xl'>
          {t('Every top image model. One subscription.')}
        </h2>
        <p className='mx-auto mt-4 max-w-2xl text-lg text-slate-400'>
          {t(
            'GPT Image 2, Nano Banana Pro, Seedream 5.0, FLUX.2, Ideogram and more — compare them side by side on the same prompt.',
          )}
        </p>
      </div>
      <div className='mt-10'>
        <ImageModelChipsMarquee />
      </div>
      <div className='mx-auto mt-12 grid max-w-4xl grid-cols-2 gap-8 px-4 sm:px-6 md:grid-cols-4'>
        {HIGHLIGHTS.map(([value, label]) => (
          <div key={label} className='text-center'>
            <div className='text-3xl font-extrabold tracking-tight text-white md:text-4xl'>
              {value}
            </div>
            <div className='mt-1 text-sm text-slate-400'>{t(label)}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ImageModelsBand;
